<template>
  <div :class="['toggle', this.component_value==1 ? 'toggle_checked' : '']" @click="ToggleValue">
    <span :class="['togglespan', this.component_value==1 ? 'togglespan_checked' : '']"></span>
  </div>
</template>

<script>



export default {
  name: 'GrcCheckboxMobile2',
  components:
  {

  },
  props: {
  },
  data () {
    return {
      component_value:0,
      readonly: false
    }
  },
  watch : {
  },

  created: function()
  {
  },
  computed: {
  },
  methods: {

    SetReadonly(pReadonly)
    {
      this.readonly = pReadonly;
    },

    IsReadonly()
    {
      return (this.readonly);
    },

    SetValue(pValue)
    {
      this.component_value = pValue;
      this.$emit("valuechanged");
    },

    GetValue()
    {
      return this.component_value;
    },

    ToggleValue()
    {
        if (this.readonly) { return; }

        if (this.component_value==0) { this.SetValue(1); }
        else { this.SetValue(0); }

        
    }


    

    
  }
}
</script>

<style scoped>

.toggle
{
  box-sizing: border-box;
  position: relative;
  display: block;
  width: 40px;
  height: 20px;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  transform: translate3d(0,0,0);
}

.toggle::before
{
    content: "";
    position: relative;
    top: 3px;
    left: 3px;
    width: 34px;
    height: 14px;
    display: block;
    background: #ccc;
    border-radius: 8px;
    transition: background .2s ease;
}

.togglespan
{
    position: absolute;
    top: 0;
    left: 0;
    width: 20px;
    height: 20px;
    display: block;
    background: white;
    border-radius: 10px;
    box-shadow: 0 0px 4px rgba(0,0,0,.5);
    transition: all .2s ease;
}

.togglespan::before
{
    content: "";
    position: absolute;
    display: block;
    margin: -18px;
    width: 56px;
    height: 56px;
    background: rgba(2,44,93,.5);
    border-radius: 50%;
    transform: scale(0);
    opacity: 1;
    pointer-events: none;
}

.toggle_checked::before
{
    background:#ccc;
}

.togglespan_checked
{
    background: rgb(30,144,255);
    transform: translateX(20px);
    transition: all .2s cubic-bezier(.8,.4,.3,1.25), background .15s ease;
    box-shadow: 0 3px 8px rgba(2,44,93,.2);
}

.togglespan_checked::before
{
      transform: scale(1);
      opacity: 0;
      transition: all .4s ease;
}

</style>